import React from 'react';
import { ShoppingCartIcon, MinusIcon, PlusIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { useStore } from '../../lib/store';
import { haptics } from '../../lib/utils/haptics';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';
interface StickyBottomActionsProps {
  product: {
    id: string | number;
    name: string;
    price: number;
    images: string[];
    brand?: string;
    inStock: boolean;
  };
}
export function StickyBottomActions({
  product
}: StickyBottomActionsProps) {
  const navigate = useNavigate();
  const productId = typeof product.id === 'string' ? parseInt(product.id) : product.id;
  const {
    cart,
    addToCart,
    updateQuantity
  } = useStore();
  const cartItem = cart.find(item => item.id === productId);
  const quantity = cartItem?.quantity || 0;
  const isInCart = quantity > 0;
  const handleAddToCart = () => {
    haptics.success();
    addToCart({
      id: productId,
      name: product.name,
      price: product.price,
      image: product.images[0],
      brand: product.brand
    });
    toast.success(`${product.name} added to cart!`);
  };
  const handleIncrement = () => {
    haptics.light();
    updateQuantity(productId, quantity + 1);
  };
  const handleDecrement = () => {
    haptics.light();
    updateQuantity(productId, quantity - 1);
  };
  const handleBuyNow = () => {
    haptics.impact();
    if (quantity === 0) {
      addToCart({
        id: productId,
        name: product.name,
        price: product.price,
        image: product.images[0],
        brand: product.brand
      });
    }
    navigate('/checkout');
  };
  return <div className="lg:hidden fixed bottom-[68px] left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-40 safe-area-bottom" data-id="element-5377" data-mp="9pluhalg9kkz">
      <div className="px-4 py-3" data-id="element-5378" data-mp="4tx15p00wzx4">
        {!isInCart ?
      // Initial state: Add to Cart (50%) + Buy Now with Apple Pay (50%)
      <div className="flex items-center gap-2 animate-fadeIn" data-id="element-5379" data-mp="eqjlmcoftoym">
            <button onClick={handleAddToCart} disabled={!product.inStock} className="flex-1 bg-white border-2 border-[#1E2B55] text-[#1E2B55] font-bold py-3 px-4 rounded-lg hover:bg-gray-50 transition-colors flex items-center justify-center gap-2 disabled:bg-gray-300 disabled:cursor-not-allowed disabled:border-gray-300" data-id="element-5380" data-mp="eo6ub8wsi28w">
              <ShoppingCartIcon className="w-5 h-5" data-id="element-5381" data-mp="10jf937qt8tcj" />
              Add to Cart
            </button>
            <button onClick={handleBuyNow} className="flex-1 bg-black text-white font-bold py-3 px-4 rounded-lg hover:bg-gray-800 transition-colors flex items-center justify-center gap-2" data-id="element-5382" data-mp="15gxmpbfrvwqv">
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-5383" data-mp="1jgyjaep08i0j">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" data-id="element-5384" data-mp="1jevutz3i2wxx" />
              </svg>
              Buy Now
            </button>
          </div> :
      // After adding to cart: Quantity controls (50%) + Buy Now (50%)
      <div className="flex items-center gap-2" data-id="element-5385" data-mp="38y3wy6htxl26">
            {/* Quantity Controls */}
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} className="flex-1 flex items-center border-2 border-[#00A651] rounded-lg bg-[#00A651] text-white shadow-lg shadow-green-900/20" data-id="element-5386" data-mp="38w9b8pyqhox1">
              <button onClick={handleDecrement} className="p-2.5 hover:bg-[#008c44] transition-colors rounded-l-lg flex-1" aria-label="Decrease quantity" data-id="element-5387" data-mp="3rp4wowqrxkms">
                <MinusIcon className="w-5 h-5 text-white mx-auto" data-id="element-5388" data-mp="3hsid0ba6ozmc" />
              </button>
              <motion.div key={quantity} initial={{
            scale: 1.2
          }} animate={{
            scale: 1
          }} className="px-3 py-2 min-w-[50px] text-center font-bold text-white border-x-2 border-[#008c44]" data-id="element-5389" data-mp="2bbmyuz19v3fd">
                {quantity}
              </motion.div>
              <button onClick={handleIncrement} className="p-2.5 hover:bg-[#008c44] transition-colors rounded-r-lg flex-1" aria-label="Increase quantity" data-id="element-5390" data-mp="3l8thskpjd9uh">
                <PlusIcon className="w-5 h-5 text-white mx-auto" data-id="element-5391" data-mp="hogwj5p63ia5" />
              </button>
            </motion.div>
            {/* Buy Now Button */}
            <button onClick={handleBuyNow} className="flex-1 bg-[#1E2B55] text-white font-bold py-3 px-4 rounded-lg hover:bg-[#162041] transition-colors" data-id="element-5392" data-mp="7t5fuhu780zr">
              Buy Now
            </button>
          </div>}
      </div>
    </div>;
}